export default __webpack_public_path__ + "static/media/tank_4.427145b0.png";